import { PublicClientApplication, Configuration } from '@azure/msal-browser';

const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID || '',
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
};

// Singleton MSAL instance — shared across the app
export const msalInstance = new PublicClientApplication(msalConfig);

// This promise MUST be awaited before React renders.
// When the popup redirects back to our app with #code=..., this call:
//   1. Reads the auth code from the URL hash
//   2. Detects it's a popup response (from the state parameter)
//   3. Exchanges the code for tokens
//   4. Posts the result back to the parent window
//   5. Closes the popup automatically
export const msalInitPromise = msalInstance.initialize().catch((err) => {
    console.warn('MSAL initialization error:', err);
    return null;
});
